import { render, staticRenderFns } from "./ClinicBankManage.vue?vue&type=template&id=0a70f02c&scoped=true"
import script from "./ClinicBankManage.vue?vue&type=script&lang=js"
export * from "./ClinicBankManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a70f02c",
  null
  
)

export default component.exports